module.exports = __webpack_public_path__ + "img/image5.5ce48348.png";